"use strict";

module.exports = require("./is-implemented")() ? Math.sign : require("./shim");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/math/sign/index.js
// module id = ../../../node_modules/es5-ext/math/sign/index.js
// module chunks = 1